import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { refetchSelectedItemBackendData } from '../../../store/autoform/autoformApi';
import useAutoformTableMetadata from './useAutoformTableMetadata';

const useAutoformReloadItemData = (tableId, itemId) => {
    const { primaryKeyColumnName } = useAutoformTableMetadata(tableId);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);
    const dispatch = useDispatch();

    const reLoadOnSelect = useCallback(() => {
        return dispatch(
            refetchSelectedItemBackendData({
                tableId,
                itemId,
                primaryKeyColumnName,
            })
        );
    }, [dispatch, primaryKeyColumnName, tableId, itemId]);

    useEffect(() => {
        if (tableId && itemId) {
            setIsLoading(true);
            const metadataPromise = reLoadOnSelect();
            metadataPromise
                .then((action) => {
                    if (!action.meta.aborted) {
                        setIsLoading(false);
                    }
                })
                .catch((err) => setLoadingError(true));
            return () => {
                metadataPromise?.abort();
            };
        }
    }, [reLoadOnSelect, tableId, itemId]);

    return { isLoading, loadingError, reLoadOnSelect };
};

export default useAutoformReloadItemData;
